export class RolePermissions {
    canViewHomeBtn: boolean;
    canViewNotificationsBtn: boolean;
    canViewOrdersBtn: boolean;
    canViewInspectionsBtn: boolean;
    canViewReleasesBtn: boolean;
    canViewNonCompliancesBtn: boolean;
    canViewDocumentsBtn: boolean;
    canViewTrashBtn: boolean;
    canViewSettingsBtn: boolean;
    canViewLogoutBtn: boolean;
    canViewArchiviBtn: boolean;
    canViewAdminBtn: boolean;

    constructor(){
    }
}

